import requestBuilder from '@/services/graphql/requestBuilder';
import { ASYNC_SEARCH_RESULT } from '../fragments';
import {
  SEARCH_COLLECTIONS_V3, SEARCH_COMMUNITY_COLLECTIONS_V3,
} from '@/constants/searching/searchingAsyncV2';
export default {
  asyncCommunityCollectionsV3(initVariables) {
    const { manufacturerQuery: query, collectionsFilters: filters } = initVariables ?? {
    };
    const variables = {
      ...initVariables,
      manufacturerQuery: undefined,
      collectionsFilters: undefined,
      ...(query && {
        query,
      }),
      filters,
    };
    return new requestBuilder({
      requestName: SEARCH_COMMUNITY_COLLECTIONS_V3,
      requestVariables: {
        filters: 'searchFilters',
        limit: 'Int',
        query: 'String',
        requestId: 'String',
        scrollID: 'String',
        sort: 'SearchSortingOptions',
        workspaceId: 'String',
      },
      response: ASYNC_SEARCH_RESULT,
      variables,
    }).processRequest();
  },
  asyncCollectionsV3(initVariables) {
    const { manufacturerQuery: query, collectionsFilters: filters } = initVariables ?? {
    };
    const variables = {
      ...initVariables,
      manufacturerQuery: undefined,
      collectionsFilters: undefined,
      ...(query && {
        query,
      }),
      filters,
    };
    return new requestBuilder({
      requestName: SEARCH_COLLECTIONS_V3,
      requestVariables: {
        filters: 'searchFilters',
        followedOnly: 'Boolean',
        libraryId: 'String',
        limit: 'Int',
        myCollections: 'Boolean',
        pageId: 'String',
        query: 'String',
        requestId: 'String',
        scrollID: 'String',
        workspaceId: 'String',
      },
      response: ASYNC_SEARCH_RESULT,
      variables,
    }).processRequest();
  },
};
